<script setup>

const colorMode = useColorMode()

const props = defineProps({
	track: {
		type: Object
	},
	indexTrack: {
		type: Number
	},
	active: {
		type: Boolean,
		default: false
	}
})

const audioRef = ref(null)

const isPlaying = ref(false)
const currentTime = ref(0)
const duration = ref(0)
const progress = ref(0)

const togglePlay = () => {
  const audio = audioRef.value
  if (!audio) return

  if (audio.paused) {
    audio.play()
    isPlaying.value = true
    updateProgress() // spustit animaci
  } else {
    audio.pause()
    isPlaying.value = false
    cancelAnimationFrame(animationFrameId)
  }
}


let animationFrameId = null

const updateProgress = () => {
  const audio = audioRef.value
  if (!audio) return

  currentTime.value = audio.currentTime
  progress.value = (audio.currentTime / duration.value) * 100

  animationFrameId = requestAnimationFrame(updateProgress)
}

const setDuration = () => {
  const audio = audioRef.value
  if (!audio) return

  duration.value = audio.duration
}

const seek = (event) => {
  const container = event.currentTarget
  const clickX = event.offsetX
  const width = container.clientWidth

  const newTime = (clickX / width) * duration.value
  audioRef.value.currentTime = newTime
  updateProgress()
}

const convertStoMs = (seconds) => {
	return `${Math.floor(seconds / 60)} : ${('0' + Math.floor(seconds % 60)).slice(-2)}`
}

watch(() => props.active,(val,oldVal)=>{
	console.log(props.active)
	if (val === false && oldVal === true && props.track?.sample) {
		audioRef.value.pause()
		audioRef.value.currentTime = 0
		currentTime.value = 0
	}
})      

</script>

<template>
	<div>
		<div
			@click.prevent="track.sample ? togglePlay() : ''"
			class="cursor-pointer xl:text-lg dark:text-light text-dark dark:hover:bg-dark8 hover:bg-lightText px-3 md:px-6 transition-all"
			:class="[active && track.sample ? 'py-8 dark:bg-dark8 bg-lightText' : 'py-2']"
		>
			<div class="flex items-center w-full justify-between">
				<div class="flex items-center">
					<span class="block w-6 md:w-8 top-[2px] relative">{{ indexTrack }}.</span>
					<div v-if="track.sample" class="flex items-center md:mr-5">
						<svg v-if="!isPlaying" class="mx-4 md:mx-5 w-[25px] basis-[25px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
							<circle cx="12.5" cy="12.5" r="12.5" :fill="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'"/>
							<path d="M17 12.5L10 8V17L17 12.5Z" :fill="colorMode.preference === 'dark' ? '#1D1D1B' : '#F5F5F5'" :stroke="colorMode.preference === 'dark' ? '#1D1D1B' : '#F5F5F5'" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
						</svg>
						<svg v-else class="mx-4 md:mx-5 w-[25px] basis-[25px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
							<circle cx="12.5" cy="13" r="11.5" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2"/>
							<path d="M14 17H15V8H14V17Z" :fill="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"/>
							<path d="M10 17H11V8H10V17Z" :fill="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-linecap="square" stroke-linejoin="bevel"/>
						</svg>
						
					</div>
				</div>
				<div class="min-w-0 truncate pr-2 w-full">
					{{ track.name }}
				</div>
				<div v-if="track.duration" class="whitespace-nowrap">
					{{ convertStoMs(track.duration) }}
				</div>
			</div>
			<div v-if="track.sample" class="collapsible" :class="{ 'is-open pt-6': active }">
				<div class="collapsible-inner px-4 ">
					<div class="w-full relative h-6 dark:bg-[#575755] bg-lightBg8 flex items-center text-xs" @click.stop="seek($event)">
						<span class="absolute z-10 left-6">{{ $t('album.sample-is-playing') }}</span>
						<div class="progress bg-red" :style="{ width: progress + '%' }"></div>
					</div>
					<Button @click.stop :to="track.url" is-small target class="mt-7">{{ $t('album.buy-track') }}</Button>
				</div>
			</div>
		</div>
		<audio
      v-if="track.sample"
      ref="audioRef"
      :src="track.sample.stream"
      @timeupdate="updateProgress"
      @loadedmetadata="setDuration"
      @ended="() => cancelAnimationFrame(animationFrameId)"
    ></audio>
	</div>
</template>

<style lang="scss" scoped>

	.collapsible {
		display: grid;
		grid-template-rows: 0fr;
		transition: grid-template-rows 500ms;

		& > .collapsible-inner {
			overflow: hidden;
		}

		&.is-open {
			grid-template-rows: 1fr;
		}
	}

	.progress {
		height: 100%;
		width: 0%;
		transition: width 0.1s linear;
	}

</style>